"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APQRCode = _interopRequireDefault(require("../common/APQRCode/APQRCode"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APAutoTabInput = _interopRequireDefault(require("../common/APAutoTabInput/APAutoTabInput"));
var _APInput = _interopRequireDefault(require("../common/APInput/APInput"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _formValidations = require("../../helpers/formValidations");
var _config = _interopRequireDefault(require("../../config"));
require("./Enable2FAModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('enable-2fa-modal');
var Enable2FAForm = function Enable2FAForm(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('auth'),
    t = _useTranslation.t;
  var GoogleQRCode = props.GoogleQRCode,
    handleSubmit = props.handleSubmit,
    userName = props.userName;
  var siteName = _config["default"].global.siteName;
  var code = "otpauth://totp/".concat(userName, "?secret=").concat(GoogleQRCode, "&issuer=").concat(encodeURI(siteName));
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isUsingYubikey = _useState2[0],
    setUsingYubikey = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, isUsingYubikey ? /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses(),
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ol", {
    className: baseClasses('text-container')
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: baseClasses('text-item')
  }, t('Insert your Yubikey and press it.')), /*#__PURE__*/_react["default"].createElement("li", {
    className: baseClasses('text-item')
  }, t("When you're done, click the button to submit.")), /*#__PURE__*/_react["default"].createElement("li", {
    className: baseClasses('text-item')
  }, /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    name: "otp",
    validate: [_formValidations.required],
    type: "password"
  }))), /*#__PURE__*/_react["default"].createElement(_APButton["default"], null, t('Submit'))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setUsingYubikey(false);
    },
    className: "link --small-font"
  }, t('Click here to scan a QR Code instead.')))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ol", {
    className: baseClasses('text-container')
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: baseClasses('text-item')
  }, t('Download a Two-Factor Authentication app to your phone such as Authy or Google Authenticator')), /*#__PURE__*/_react["default"].createElement("li", {
    className: baseClasses('text-item')
  }, t('Use the app to scan QR code.')), /*#__PURE__*/_react["default"].createElement("li", {
    className: baseClasses('text-item')
  }, t('Type in code from your phone.'))), /*#__PURE__*/_react["default"].createElement(_APAutoTabInput["default"], {
    name: "code",
    type: "number",
    numberOfInputs: 6,
    validate: [_formValidations.required]
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setUsingYubikey(true);
    },
    className: "link --small-font"
  }, t('Click here to use Yubikey for second factor.')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('qr-code')
  }, /*#__PURE__*/_react["default"].createElement(_APQRCode["default"], {
    value: code
  }))));
};
Enable2FAForm.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
Enable2FAForm.propTypes = {
  handleSubmit: _propTypes["default"].func
};
var _default = exports["default"] = Enable2FAForm;